import { createReducer, on } from '@ngrx/store';
import { loadPermissionsSuccess } from './permissions.actions';
import { IPermissions } from '@interfaces';

export interface PermissionsState {
  permissions: IPermissions[];
}

export const initialState: PermissionsState = {
  permissions: [],
};

const _permissionsReducer = createReducer(
  initialState,
  on(loadPermissionsSuccess, (state, { permissions }) => ({ ...state, permissions })),
);

export function permissionsReducer(state: PermissionsState | undefined, action: any) {
  return _permissionsReducer(state, action);
}
